const leaflets = {
    "client": {
        "config": {
            "primary_color": "#01538A",
            "secondary_color": "#E1001B",
            "tertiary_color": "#ffdd00",
            "hover_color": "rgba(220, 35, 17, 0.5)",
            "primary-alpha-color": "rgba(35, 94, 157, 0.7)",
            "clientIcon": "/media/images/logo_apulia.png",
            "serverPath": "demoapulia.interattivo.net/",
            "pdfPath": "/media/pdf/volantino.pdf",
            "shareFlyerTitle": "Volantino interattivo",
            "shareFlyerURL": "https://demoapulia.interattivo.net?v=647",
            "shareProductSentence": "Guarda il nuovo volantino di Carrefour",
            "ogTitleMeta": "Carrefour | Volantino interattivo",
            "ogDescriptionMeta": "Dai uno sguardo al volantino interattivo di Carrefour. Offerte valide dal 9 al 21 novembre",
            "ogImageMeta": "https://demoapulia.interattivo.net/media/images/fb.png",
            "ogImageMeta_mobile": "https://demoapulia.interattivo.net/media/images/wa.jpg",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": false,
            "ga_tracking_id": "",
            "release_id": "1",
            "send_grocery_list_to_market": true,
            "grocery_list_min_value": 1,
            "client_id": 11,
            "signboard_id": 33,
            "has_pages": true,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "line_through": false,
            "category_banner": "",
            "category_banner_mobile": "",
            "hide_plus_product": false,
            "hide_plus_product_price": false,
            "product_banner": "",
            "href_banner": "",
            "internal_banner_click": false,
            "external_banner_click": false,
            "hide_listPages": false,
            "type": "leaflet",
            "pager": "buttons",
            "version": 647
        },
        "leaflet": {
            "name": "Demo carfour",
            "code": "647",
            "id_campaign": "647",
            "index": {
                "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/pages/indice_OXwOQuz.png",
                "links": [
                    {
                        "page": 2,
                        "blueprint": {
                            "top": 29.767441860465116,
                            "left": 6.9476744186046515,
                            "width": 87.1220930232558,
                            "height": 10.959302325581394
                        }
                    },
                    {
                        "page": 3,
                        "blueprint": {
                            "top": 40.72674418604652,
                            "left": 6.9476744186046515,
                            "width": 87.1220930232558,
                            "height": 10.552325581395348
                        }
                    },
                    {
                        "page": 4,
                        "blueprint": {
                            "top": 51.27906976744186,
                            "left": 6.9476744186046515,
                            "width": 87.1220930232558,
                            "height": 10.66860465116279
                        }
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Self Service",
                    "subcategories": [
                        "Yogurt",
                        "Formaggi",
                        "Snack",
                        "Salumi"
                    ]
                },
                {
                    "category_name": "Alimentari",
                    "subcategories": [
                        "Dispensa",
                        "Rossi",
                        "Pasta"
                    ]
                },
                {
                    "category_name": "Surgelati",
                    "subcategories": [
                        "Gelati",
                        "Ittico"
                    ]
                },
                {
                    "category_name": "Macelleria",
                    "subcategories": [
                        "Bovino",
                        "Altro",
                        "Avicoli",
                        "Suino",
                        "Equino"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/pages/page_1_OxGTL9C.jpg",
                    "products": [
                        {
                            "item_id": "cstm76707695",
                            "field1": "VITAL",
                            "field2": "yogurt magro 500g",
                            "field3": "",
                            "field4": "",
                            "description": "VITAL yogurt magro 500g",
                            "grammage": null,
                            "price": "3.95",
                            "price_label": "€ 3,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "magro",
                                "fragola"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 23.179489965770514,
                                "left": 2.5738798856053386,
                                "width": 29.74261201143947,
                                "height": 40.700000493932045
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/download_1_ixLnb7H.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/images_0td71eE.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_2DLD3Hc_cnkAJpF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "title": "",
                                    "data": {
                                        "specifiche": "per 100g \r\nCalorie: 42kcal, Gras: 0,10g, Carb: 5,70g, Prot: 4,50g  ",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/images/download_1_ixLnb7H.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm66515549",
                            "field1": "JOCCA",
                            "field2": "senza lattosio 500gr",
                            "field3": "",
                            "field4": "",
                            "description": "JOCCA senza lattosio 500gr",
                            "grammage": null,
                            "price": "3.95",
                            "price_label": "€ 3,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 60.619538963829356,
                                "left": 2.3832221163012393,
                                "width": 33.094472768872116,
                                "height": 32.20436932286856
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/download_3_uvaN0Wd.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_TpNz8k2_x5If6Ku.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.jocca.it/scopri_jocca/Jocca"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm70618544",
                            "field1": "SIMMENTHAL",
                            "field2": "insalate di pollo",
                            "field3": "500gr",
                            "field4": "",
                            "description": "SIMMENTHAL insalate di pollo 500gr",
                            "grammage": null,
                            "price": "3.95",
                            "price_label": "€ 3,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 42.146480487214575,
                                "left": 28.408007626310773,
                                "width": 35.92221722832772,
                                "height": 21.184843083318448
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/download_4_5LEvbrC.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_xHSNeo6_1zMzKY9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Insalata di pollo",
                                        "testo": "L'esperienza Simmenthal in una ricetta dal gusto unico e particolare, dato anche dalla presenza dell'uvetta. -30% di grassi rispetto alla media delle insalate in conserva di pesce e carne più vendute. (fonte: simmenthal.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/images/download_4_5LEvbrC_u22v0EF.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm26900195",
                            "field1": "CORNETTO",
                            "field2": "classico/cioccolato",
                            "field3": "500gr",
                            "field4": "",
                            "description": "CORNETTO classico/cioccolato 500gr",
                            "grammage": null,
                            "price": "3.95",
                            "price_label": "€ 3,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "classico",
                                "cioccolato"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 24.463713282326623,
                                "left": 64.10988836886985,
                                "width": 31.981627360396143,
                                "height": 44.4585204289872
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/download_6_dExVY7h.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/0287498_A_1_A_J8xD2D4.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_RDSeBkK_PjFsoA7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/video/Cornetto_-_Questestate_la_passo_con_te_2021.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm83813519",
                            "field1": "FINDUS",
                            "field2": "4 fiori di merluzzo",
                            "field3": "500gr",
                            "field4": "",
                            "description": "FINDUS 4 fiori di merluzzo 500gr",
                            "grammage": null,
                            "price": "3.95",
                            "price_label": "€ 3,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 62.39358688047724,
                                "left": 34.893314594064556,
                                "width": 29.245753043496745,
                                "height": 31.31939908691339
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/download_7_XIsXFw7.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_Iexq8y5_LDlAqg5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Fiori di Merluzzo con confit di pomodorini, olive e capperi sott'olio",
                                    "data": {
                                        "ingredients": "80 gr di pomodorini ciliegia a metà, 1 cucchiaio di capperi dissalati, 7-8 olive nere con nocciolo, 1/2 bicchiere di olio EVO, 30 gr di porro fresco a rondelle, 1 pizzico di sale, Q.b. di pepe nero Kambot, 1 cucchiaino di zucchero di canna, 1 rametto di menta fresca ",
                                        "recipe": "In una ciotola unire i pomodorini, il sale, lo zucchero e un cucchiaio dell'olio, condire bene il tutto e poi disporre i pomodorini su un piatto antiaderente da microonde. Cuocerli alla massima potenza per 8-10 minuti o finché non risultino sufficientemente raggrinziti; i tempi possono variare a seconda del forno a microonde.\r\nNel frattempo cuocere i Fiori di Merluzzo seguendo le istruzioni riportate sul retro del pacco.\r\nIn un pentolino delle piccole dimensioni, aggiungere il porro, le olive, i capperi e il rametto di menta, conservando le foglie da parte per dopo. Porlo sul fuoco a fuoco bassissimo e farlo cuocere finchè non inizierà a sfrigolare, spegnere subito e lasciar intiepidire. Aggiungere i pomodorini già appassiti nell'olio. Nel piatto posizionare i Fiori e condire con l'olio profumato creato avendo cura di distribuire equamente tutti gli elementi. Spolverare con il pepe Kambot macinato al momento e servire guarnendo con qualche fogliolina di menta tenuta da parte.\r\n(fonte: findus.it)\r\n\r\n",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/images/3D-Cap-Fiori-Merluzzo.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm84003792",
                            "field1": "GALBANI",
                            "field2": "galbanino",
                            "field3": "500gr",
                            "field4": "",
                            "description": "GALBANI galbanino 500gr",
                            "grammage": null,
                            "price": "3.95",
                            "price_label": "€ 3,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 67.99165970508072,
                                "left": 66.4891413066966,
                                "width": 33.510858693303405,
                                "height": 25.622539853344055
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/download_nXYDzOQ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_7wYjmFM_NoGH9Ue.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "title": "Ingredienti",
                                    "data": {
                                        "specifiche": "Formaggi, acqua, proteine del latte, siero di latte in polvere, burro, sali di fusione: citrato di sodio, sale, correttore di acidità: acido citrico, Può contenere tracce di uova (Fonte: galbani.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/images/download.jpg"
                                        ]
                                    }
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Descrizione",
                                        "testo": "Galbanino \"Fior di Fette\", pratiche fette quadrate di formaggio fuso, singolarmente confezionate, da tenere sempre in frigorifero. Fatte con tanto buon formaggio, sono ideali per farcire panini e toast. Provale anche nelle tue ricette a caldo, per creare piatti filanti e gustosi. Galbanino \"Fior di Fette\": il gusto e la bontà del latte diventano ancora più pratici. Conservare a temperatura max + 4 °C (Fonte: galbani.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/images/download_0Cygx8C.jpg"
                                        ]
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/pages/page_2_nfhpXgp.jpg",
                    "products": [
                        {
                            "item_id": "cstm46052879",
                            "field1": "BARILLA",
                            "field2": "sughi pronti",
                            "field3": "basilico/ pomodori e datterini",
                            "field4": "",
                            "description": "BARILLA sughi pronti basilico/ pomodori e datterini",
                            "grammage": null,
                            "price": "3.95",
                            "price_label": "€ 3,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 4.607645080189871,
                                "left": 4.57578646329838,
                                "width": 46.36195452669921,
                                "height": 46.16706337273462
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/Basilico_400g_it_TjsJUbR.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/11456_sizEemb.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_caiusCE_IeT5G5F.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.barilla.com/it-it/prodotti/sughi/sugo-al-basilico"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm04259078",
                            "field1": "RIO MARE",
                            "field2": "filetto di salmone",
                            "field3": "500gr",
                            "field4": "",
                            "description": "RIO MARE filetto di salmone 500gr",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 12.708130615389937,
                                "left": 53.574833174451854,
                                "width": 20.30505243088656,
                                "height": 16.694903115229405
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/71TyfsmmL._AC_SL1500__Q5Z6qbB.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_kKVwEil_SiMHVMn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Filetto di Salmone Grigliato",
                                        "testo": "Con il Filetto di Salmone Grigliato all’Olio Extra Vergine di Oliva Rio Mare porti in tavola il gusto unico di un filetto di Salmone di prima qualità (Salmo Salar), integro, tenero e senza lische, grigliato delicatamente e condito con il nostro miglior olio extra vergine di oliva. E’ ideale per un piatto nutriente dal gusto autentico e irresistibile. \r\n(fonte: riomare.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/images/salmone-grigliat-ex-oliva.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm05638174",
                            "field1": "TULIP",
                            "field2": "Jamonilla",
                            "field3": "500gr",
                            "field4": "",
                            "description": "TULIP Jamonilla 500gr",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 9.151819892619176,
                                "left": 73.97521448999046,
                                "width": 24.976167778836988,
                                "height": 20.54757306489773
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_bmlINNG_L5nM4aA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80269081",
                            "field1": "SIMMENTHAL",
                            "field2": "insalate di pollo gr 500",
                            "field3": "",
                            "field4": "",
                            "description": "SIMMENTHAL insalate di pollo gr 500",
                            "grammage": null,
                            "price": "0.00",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 31.181189092004722,
                                "left": 48.42707340324119,
                                "width": 24.976167778836988,
                                "height": 20.54757306489773
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_mFXarhM_SuWhrzS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Insalata di Pollo ",
                                        "testo": "L'esperienza Simmenthal in una ricetta dal gusto unico e particolare, dato anche dalla presenza dell'uvetta. -30% di grassi rispetto alla media delle insalate in conserva di pesce e carne più vendute. (fonte: simmenthal.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/images/download_4_5LEvbrC.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm99594904",
                            "field1": "RIO MARE",
                            "field2": "filetto di sgombro",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "RIO MARE filetto di sgombro gr 500",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 31.477548318902297,
                                "left": 74.45185891325072,
                                "width": 24.976167778836988,
                                "height": 20.54757306489773
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_A4xLIBJ_ZMNV0WM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm75047718",
                            "field1": "SIMMENTHAL",
                            "field2": "",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "SIMMENTHAL gr 500",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 55.97657774243419,
                                "left": 1.143946615824595,
                                "width": 25.548141086749286,
                                "height": 17.781553613853806
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_4rGoHXY_7plopgX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/video/Simmenthal_Spot_2015.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm93650367",
                            "field1": "GALLO",
                            "field2": "riso arborio",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "GALLO riso arborio gr 500",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 49.950606795517075,
                                "left": 27.16873212583413,
                                "width": 23.069590085795998,
                                "height": 23.41237892490751
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_6Y66Vur_JirCjV3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm39393455",
                            "field1": "BARILLA",
                            "field2": "emiliane pappardelle",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "BARILLA emiliane pappardelle gr 500",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 50.04939320448293,
                                "left": 50.90562440419447,
                                "width": 23.069590085795998,
                                "height": 23.41237892490751
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_8L5dXhO_tDgdc2g.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.barillagroup.com/it/"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm36422674",
                            "field1": "BARILLA",
                            "field2": "ragu contadino",
                            "field3": "",
                            "field4": "",
                            "description": "BARILLA ragu contadino",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 51.23483011207318,
                                "left": 74.07054337464253,
                                "width": 23.069590085795998,
                                "height": 21.831796381453838
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/Ragu_contadino_400g_it_vkUHox1.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_dKHtjd6_eo3HnS5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Descrizione",
                                        "testo": "Carne di maiale da filiera controllata, soffritto, pomodoro e vino rosso: è il ragù saporito della gastronomia campagnola, cotto pazientemente a fuoco lento, senza l'aggiunta di conservanti. Pronto per regalare alla tua pasta il sapore della buona cucina italiana. (Fonte: barilla.com)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/images/Ragu_contadino_400g_it.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm08749066",
                            "field1": "SIMMENTHAL",
                            "field2": "insalate di pollo",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "SIMMENTHAL insalate di pollo gr 500",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 73.22888317025345,
                                "left": 74.73784556720688,
                                "width": 23.069590085795998,
                                "height": 21.831796381453838
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_hlTWeeJ_remDfVe.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm06455240",
                            "field1": "RIO MARE",
                            "field2": "filetto di salmone",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "RIO MARE filetto di salmone gr 500",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 74.21674725991198,
                                "left": 50.714966634890374,
                                "width": 23.069590085795998,
                                "height": 21.831796381453838
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_kvA7xhk_ueuJH9a.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm66175446",
                            "field1": "GAROFALO",
                            "field2": "calamarata",
                            "field3": "gr 500",
                            "field4": "",
                            "description": "GAROFALO calamarata gr 500",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 73.72281521508272,
                                "left": 27.264061010486177,
                                "width": 23.069590085795998,
                                "height": 21.831796381453838
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_ugDvsLy_u5YzT96.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm24693763",
                            "field1": "RANA",
                            "field2": "gnocchi ",
                            "field3": "",
                            "field4": "",
                            "description": "RANA gnocchi ",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 73.42645598818515,
                                "left": 2.4785510009532885,
                                "width": 23.069590085795998,
                                "height": 21.831796381453838
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_Zt4U7iE_Wnqvyl2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/pages/page_3_gFmsKMT.jpg",
                    "products": [
                        {
                            "item_id": "cstm42352803",
                            "field1": "gusto volta",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "gusto volta",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 7.9602013772992954,
                                "left": 72.84973935938594,
                                "width": 23.30946278927931,
                                "height": 21.393038621589323
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_e3eSmBH_p0eKAUf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm26239759",
                            "field1": "babybell",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "babybell",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 7.9602013772992954,
                                "left": 52.11007462686567,
                                "width": 20.73966473252027,
                                "height": 21.393038621589323
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_S9LnnX5_B9Nps9I.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/video/Spot_Mini_Babybel.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm12379075",
                            "field1": "Formaggini",
                            "field2": "crema bel paese",
                            "field3": "",
                            "field4": "",
                            "description": "Formaggini crema bel paese",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 29.35323999888862,
                                "left": 49.589552238805965,
                                "width": 23.26018712057997,
                                "height": 23.00994645303755
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_UaPsReF_v3XxlRK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm19684815",
                            "field1": "sottilette",
                            "field2": "kraft",
                            "field3": "",
                            "field4": "",
                            "description": "sottilette kraft",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 29.35323999888862,
                                "left": 72.84973935938594,
                                "width": 24.749761296741994,
                                "height": 23.00994645303755
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_KL6rVvB_WmemaNo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/video/SOTTILETTE.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm91251189",
                            "field1": "hot dog",
                            "field2": "senfter",
                            "field3": "",
                            "field4": "",
                            "description": "hot dog senfter",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Snack",
                            "blueprint": {
                                "top": 52.36318645192617,
                                "left": 72.84973935938594,
                                "width": 24.749761296741994,
                                "height": 20.895528081637714
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_0Y986Kz_uklMxQA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm08383115",
                            "field1": "accattatell",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "accattatell",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 52.36318645192617,
                                "left": 49.46951820601277,
                                "width": 23.380221153373157,
                                "height": 20.895528081637714
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_mosp03L_mCTHhgn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm61637463",
                            "field1": "parmareggio snack",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "parmareggio snack",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 52.36318645192617,
                                "left": 25.7999807898678,
                                "width": 23.669537416144983,
                                "height": 20.895528081637714
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/1580995939_841002-0010---snack-prre-20gx5_2XIWMZv.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_oCy6GBu_bpJbalR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.parmareggio.it/detail-prodotto/45"
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Descrizione",
                                        "testo": "Pratiche barrette di Parmigiano Reggiano da 20 gr, confezionate singolarmente, ideali per una pausa di gusto. Energia e buonumore per un break in ufficio, appetitoso partner di viaggio, giusta carica prima, dopo e durante l'attività sportiva. Con solo 80 calorie, Parmareggio Snack è adatto per chi vuole fare una pausa buona, naturale e genuina, sempre a portata di mano. (Fonte: parmareggio.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/images/1580995939_841002-0010---snack-prre-20gx5.png"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm60811831",
                            "field1": "philadelphia",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "philadelphia",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 52.36318645192617,
                                "left": 0,
                                "width": 25.7999807898678,
                                "height": 20.895528081637714
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_CBPpnNF_BEzDCS0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/video/Philadelphia_torna_in_tv_con_JWT_e_Il_gusto_della_complicita.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm85640027",
                            "field1": "Jocca",
                            "field2": "senza lattosio",
                            "field3": "gr.150",
                            "field4": "",
                            "description": "Jocca senza lattosio gr.150",
                            "grammage": null,
                            "price": "3.95",
                            "price_label": "€ 3,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 3.482592283789792,
                                "left": 0,
                                "width": 48.9647854477612,
                                "height": 48.88059416813637
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_PYhnn0P_h8IBKk5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm01898121",
                            "field1": "fruttolo/ nesquik",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "fruttolo/ nesquik",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "fruttolo",
                                "nesquik"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 73.25871026338038,
                                "left": 0,
                                "width": 25.799986284170576,
                                "height": 21.51741483318272
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/images_lBfuMkC_Ls8THlv.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/Nesquik_Chocoballs_YRmsTkI.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_0eZOTkt_vzULPvd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm02856811",
                            "field1": "yogurt fragola",
                            "field2": "muller",
                            "field3": "",
                            "field4": "",
                            "description": "yogurt fragola muller",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 73.05970149253733,
                                "left": 25.68295653613646,
                                "width": 23.78892668539019,
                                "height": 21.791044776119403
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_C0T5m5R_YymtliS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm88140363",
                            "field1": "yogurt kiwi",
                            "field2": "muller",
                            "field3": "",
                            "field4": "",
                            "description": "yogurt kiwi muller",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 73.05970149253733,
                                "left": 49.47188322152664,
                                "width": 23.50087797250321,
                                "height": 21.791044776119403
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_B6cw63e_2NxwA0x.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm89581379",
                            "field1": "galak/ fruttolo smarties",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "galak/ fruttolo smarties",
                            "grammage": null,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "galak",
                                "fruttolo smarties"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 73.05970149253731,
                                "left": 72.97276119402986,
                                "width": 24.989168115872054,
                                "height": 21.7910447761194
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/images_HR9SRDH_bBY2mYh.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/Sp_galak8_6VZ867J.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_wNquygp_Vru1dy5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 4,
                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/pages/page_4_nX6YZQN.jpg",
                    "products": [
                        {
                            "item_id": "cstm84568246",
                            "field1": "Salsiccia",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "Salsiccia",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 11.741292583408647,
                                "left": 3.718409791633262,
                                "width": 25.589302566869936,
                                "height": 21.5422895061436
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_Y5OcTHW_bnyk417.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm30327059",
                            "field1": "Fettina di bovino",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "Fettina di bovino",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 11.741292583408647,
                                "left": 29.307712358503196,
                                "width": 21.100375881479756,
                                "height": 21.5422895061436
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_I0Sy3rb_YLglOYT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm86349125",
                            "field1": "Macinato",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "Macinato",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 33.28358208955225,
                                "left": 29.307712358503196,
                                "width": 21.100375881479756,
                                "height": 18.756219379937477
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_YchqoNb_vJsN0sd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm96237156",
                            "field1": "Petto pollo",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "Petto pollo",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 33.28358208955225,
                                "left": 3.4783582089552216,
                                "width": 25.829354149547978,
                                "height": 18.756219379937477
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_GfFkAbc_qtvt6Uf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm57772083",
                            "field1": "Lombata black angus",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "Lombata black angus",
                            "grammage": null,
                            "price": "9.90",
                            "price_label": "€ 9,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 3.482586590211784,
                                "left": 49.92498628417058,
                                "width": 50.07501371582942,
                                "height": 49.87562378840661
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_RfDChhh_ZQsTc8s.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm83718313",
                            "field1": "salsiccia suino",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "salsiccia suino",
                            "grammage": null,
                            "price": "7.95",
                            "price_label": "€ 7,95 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 53.35821037861839,
                                "left": 74.65011249371429,
                                "width": 25.349887506285707,
                                "height": 20.149253731343286
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_ySLauH9_qw1q6iJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm49236324",
                            "field1": "pancetta",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "pancetta",
                            "grammage": null,
                            "price": "9.95",
                            "price_label": "€ 9,95 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 53.35821037861839,
                                "left": 51.1498682961535,
                                "width": 23.50024419756079,
                                "height": 20.149253731343286
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_oKavEa1_VPEVGaS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm32494984",
                            "field1": "Tritato misto",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "Tritato misto",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Altro",
                            "blueprint": {
                                "top": 53.35821037861839,
                                "left": 29.160680970149247,
                                "width": 21.989187326004252,
                                "height": 20.149253731343286
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_NCQuUdg_nQDH7sy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm98924534",
                            "field1": "fetta equino",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "fetta equino",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Equino",
                            "blueprint": {
                                "top": 53.35821037861839,
                                "left": 3.980092176750512,
                                "width": 25.18058879339874,
                                "height": 20.149253731343286
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_AtvVAkg_lJugwSG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm35483630",
                            "field1": "Pollo intero",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "Pollo intero",
                            "grammage": null,
                            "price": "9.95",
                            "price_label": "€ 9,95 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 73.50746410996167,
                                "left": 3.980092176750512,
                                "width": 25.18058879339874,
                                "height": 21.393038621589323
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_7BgNwGu_smQVEqt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm53940907",
                            "field1": "hamburger farcito",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "hamburger farcito",
                            "grammage": null,
                            "price": "7.95",
                            "price_label": "€ 7,95 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 73.50746410996167,
                                "left": 29.160680970149247,
                                "width": 23.54950887765457,
                                "height": 21.393038621589323
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_ZEVBFLm_kynTmrx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm18106419",
                            "field1": "cosce pollo",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "cosce pollo",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 73.50746410996167,
                                "left": 52.710189847803825,
                                "width": 21.5798480190448,
                                "height": 21.393038621589323
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_0crHmPw_6NjZFNR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm20907743",
                            "field1": "ali pollo",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "ali pollo",
                            "grammage": null,
                            "price": "6.90",
                            "price_label": "€ 6,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 73.50746410996167,
                                "left": 74.29003786684862,
                                "width": 23.30946278927931,
                                "height": 21.393038621589323
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/products/cropped_image_82gGcQi_6YjDrfB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 5,
                    "image_file": "https://interattivo.s3.amazonaws.com/mw4jvtdNaH/pages/Finee-Carrefour_lLveOeh.png",
                    "products": []
                }
            ]
        }
    }

}

const lefletSwitch = () => {
    return leaflets.client;
}

export const serverResponse = lefletSwitch();